var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserGrey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2 12C23.2 18.1856 18.1856 23.2 12 23.2C5.8144 23.2 0.799988 18.1856 0.799988 12C0.799988 5.8144 5.8144 0.799988 12 0.799988C18.1856 0.799988 23.2 5.8144 23.2 12ZM14.8 7.79999C14.8 9.34639 13.5464 10.6 12 10.6C10.4536 10.6 9.19999 9.34639 9.19999 7.79999C9.19999 6.25359 10.4536 4.99999 12 4.99999C13.5464 4.99999 14.8 6.25359 14.8 7.79999ZM11.9999 13.4C9.17533 13.4 6.7415 15.073 5.63522 17.482C7.17563 19.2688 9.4557 20.4 12 20.4C14.5442 20.4 16.8242 19.2689 18.3647 17.4821C17.2584 15.073 14.8245 13.4 11.9999 13.4Z",
    fill: "#2D3D45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGrey);
export default __webpack_public_path__ + "static/media/user_grey.d0b7c5a5aa571c391fe67a2768c7262f.svg";
export { ForwardRef as ReactComponent };